export interface DaisyThemeOption {
  id: string;
  name: string;
  primary: string;
  secondary: string;
  accent: string;
  base100: string;
  isDark?: boolean;
}

export const DAISY_PREBUILT_THEMES: DaisyThemeOption[] = [
  {
    id: 'light',
    name: 'Light',
    primary: '#570df8',
    secondary: '#f000b8',
    accent: '#37cdbe',
    base100: '#ffffff',
  },
  {
    id: 'dark',
    name: 'Dark',
    primary: '#661AE6',
    secondary: '#D926AA',
    accent: '#1FB2A6',
    base100: '#1D232A',
    isDark: true,
  },
  {
    id: 'cupcake',
    name: 'Cupcake',
    primary: '#651376',
    secondary: '#a644b2',
    accent: '#2dd4bf',
    base100: '#faf7f5',
  },
  {
    id: 'bumblebee',
    name: 'Bumblebee',
    primary: '#e0a82e',
    secondary: '#f9d72f',
    accent: '#181818',
    base100: '#ffffff',
  },
  {
    id: 'emerald',
    name: 'Emerald',
    primary: '#66cc8a',
    secondary: '#377cfb',
    accent: '#ea5234',
    base100: '#ffffff',
  },
  {
    id: 'corporate',
    name: 'Corporate',
    primary: '#4b6bfb',
    secondary: '#7b92b2',
    accent: '#67cba0',
    base100: '#ffffff',
  },
  {
    id: 'synthwave',
    name: 'Synthwave',
    primary: '#e779c1',
    secondary: '#58c7f3',
    accent: '#f3cc30',
    base100: '#1a103c',
    isDark: true,
  },
  {
    id: 'retro',
    name: 'Retro',
    primary: '#ef9995',
    secondary: '#a4cbb4',
    accent: '#ebdc99',
    base100: '#ece3ca',
  },
  {
    id: 'cyberpunk',
    name: 'Cyberpunk',
    primary: '#ff7598',
    secondary: '#75d1f0',
    accent: '#c075ff',
    base100: '#fff200',
  },
  {
    id: 'valentine',
    name: 'Valentine',
    primary: '#e96d7b',
    secondary: '#a991f7',
    accent: '#88dbdd',
    base100: '#f0d6e8',
  },
  {
    id: 'halloween',
    name: 'Halloween',
    primary: '#f28c18',
    secondary: '#6d0076',
    accent: '#79a86b',
    base100: '#212121',
    isDark: true,
  },
  {
    id: 'garden',
    name: 'Garden',
    primary: '#be4680',
    secondary: '#557c55',
    accent: '#b8c480',
    base100: '#e9e7e7',
  },
  {
    id: 'forest',
    name: 'Forest',
    primary: '#1eb854',
    secondary: '#1db88e',
    accent: '#1db8ab',
    base100: '#171212',
    isDark: true,
  },
  {
    id: 'aqua',
    name: 'Aqua',
    primary: '#09ecf3',
    secondary: '#966fb3',
    accent: '#ffe999',
    base100: '#345da7',
    isDark: true,
  },
  {
    id: 'lofi',
    name: 'Lofi',
    primary: '#0d0d0d',
    secondary: '#1a1a1a',
    accent: '#262626',
    base100: '#ffffff',
  },
  {
    id: 'pastel',
    name: 'Pastel',
    primary: '#d1c1d7',
    secondary: '#f6cbd1',
    accent: '#b4e9d6',
    base100: '#ffffff',
  },
  {
    id: 'fantasy',
    name: 'Fantasy',
    primary: '#6e0b75',
    secondary: '#007ebd',
    accent: '#f000b8',
    base100: '#ffffff',
  },
  {
    id: 'wireframe',
    name: 'Wireframe',
    primary: '#b8b8b8',
    secondary: '#b8b8b8',
    accent: '#b8b8b8',
    base100: '#ffffff',
  },
  {
    id: 'black',
    name: 'Black',
    primary: '#343232',
    secondary: '#343232',
    accent: '#343232',
    base100: '#000000',
    isDark: true,
  },
  {
    id: 'luxury',
    name: 'Luxury',
    primary: '#ffffff',
    secondary: '#152747',
    accent: '#513448',
    base100: '#090d16',
    isDark: true,
  },
  {
    id: 'dracula',
    name: 'Dracula',
    primary: '#ff79c6',
    secondary: '#bd93f9',
    accent: '#ffb86c',
    base100: '#282a36',
    isDark: true,
  },
  {
    id: 'cmyk',
    name: 'CMYK',
    primary: '#45aeee',
    secondary: '#e8488a',
    accent: '#fff232',
    base100: '#ffffff',
  },
  {
    id: 'autumn',
    name: 'Autumn',
    primary: '#8c0327',
    secondary: '#d85251',
    accent: '#d59b6a',
    base100: '#f1f1f1',
  },
  {
    id: 'business',
    name: 'Business',
    primary: '#1c4ed8',
    secondary: '#7c3aed',
    accent: '#06b6d4',
    base100: '#202020',
    isDark: true,
  },
  {
    id: 'acid',
    name: 'Acid',
    primary: '#ff00ff',
    secondary: '#ffbe00',
    accent: '#00e5ff',
    base100: '#fafafa',
  },
  {
    id: 'lemonade',
    name: 'Lemonade',
    primary: '#519903',
    secondary: '#e9e92f',
    accent: '#e9e92f',
    base100: '#ffffff',
  },
  {
    id: 'night',
    name: 'Night',
    primary: '#38bdf8',
    secondary: '#818cf8',
    accent: '#f472b6',
    base100: '#0f172a',
    isDark: true,
  },
  {
    id: 'coffee',
    name: 'Coffee',
    primary: '#db924b',
    secondary: '#263e3f',
    accent: '#10576d',
    base100: '#20161f',
    isDark: true,
  },
  {
    id: 'winter',
    name: 'Winter',
    primary: '#047aff',
    secondary: '#463aa5',
    accent: '#c148ac',
    base100: '#ffffff',
  },
  {
    id: 'dim',
    name: 'Dim',
    primary: '#9fe88d',
    secondary: '#ff7d5c',
    accent: '#c792ea',
    base100: '#2a303c',
    isDark: true,
  },
  {
    id: 'nord',
    name: 'Nord',
    primary: '#5e81ac',
    secondary: '#81a1c1',
    accent: '#88c0d0',
    base100: '#eceff4',
  },
  {
    id: 'sunset',
    name: 'Sunset',
    primary: '#ff865b',
    secondary: '#fd6f9c',
    accent: '#b387ff',
    base100: '#1a1c23',
    isDark: true,
  },
];

/**
 * Convert a Hex color string (e.g. #3B82F6) to OKLCH format (L% C H) required by DaisyUI 4
 */
export function hexToOklch(hex: string): string {
  if (!hex || typeof hex !== 'string') {
    return '62.3083% 0.1880 259.8145';
  }

  let cleanHex = hex.trim().replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (cleanHex.length !== 6) {
    return '62.3083% 0.1880 259.8145';
  }

  let r = parseInt(cleanHex.substring(0, 2), 16) / 255;
  let g = parseInt(cleanHex.substring(2, 4), 16) / 255;
  let b = parseInt(cleanHex.substring(4, 6), 16) / 255;

  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

  const l = 0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b;
  const m = 0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b;
  const s = 0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b;

  const l_ = Math.cbrt(l);
  const m_ = Math.cbrt(m);
  const s_ = Math.cbrt(s);

  const L = 0.2104542553 * l_ + 0.793617785 * m_ - 0.0040720404 * s_;
  const a = 1.9779984951 * l_ - 2.428592205 * m_ + 0.4505937099 * s_;
  const b_val = 0.0259040371 * l_ + 0.7827717662 * m_ - 0.8086757973 * s_;

  const C = Math.sqrt(a * a + b_val * b_val);
  let H = Math.atan2(b_val, a) * (180 / Math.PI);
  if (H < 0) H += 360;

  return `${(L * 100).toFixed(4)}% ${C.toFixed(4)} ${H.toFixed(4)}`;
}

/**
 * Calculate high-contrast OKLCH content color (text/icon) for a given background color hex
 */
export function calculateContrastOklch(bgHex: string): string {
  if (!bgHex || typeof bgHex !== 'string') {
    return '100% 0 0'; // White
  }

  let cleanHex = bgHex.trim().replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (cleanHex.length !== 6) {
    return '100% 0 0';
  }

  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  // Relative luminance
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '0% 0 0' : '100% 0 0';
}

/**
 * Generate a darkened variant of a hex color for base-200 / base-300
 */
export function adjustHexBrightness(hex: string, factor: number): string {
  let cleanHex = hex.trim().replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (cleanHex.length !== 6) return hex;

  const r = Math.max(
    0,
    Math.min(255, Math.floor(parseInt(cleanHex.substring(0, 2), 16) * factor)),
  );
  const g = Math.max(
    0,
    Math.min(255, Math.floor(parseInt(cleanHex.substring(2, 4), 16) * factor)),
  );
  const b = Math.max(
    0,
    Math.min(255, Math.floor(parseInt(cleanHex.substring(4, 6), 16) * factor)),
  );

  const toHex = (n: number) => n.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/**
 * CSS custom properties used by DaisyUI 4
 */
const DAISY_CSS_VARIABLES = [
  '--p',
  '--pc',
  '--s',
  '--sc',
  '--a',
  '--ac',
  '--n',
  '--nc',
  '--b1',
  '--b2',
  '--b3',
  '--bc',
];

export const USER_THEME_STORAGE_KEY = 'bse_user_theme_override';

/**
 * Checks if the tenant only has standard light or dark theme (no custom non-standard preset theme).
 */
export function isTenantLightDarkOnly(branding?: {
  theme?: string;
  primaryColor?: string;
  baseColor?: string;
}): boolean {
  if (!branding) return true;
  const theme = (branding.theme || '').toLowerCase().trim();
  const specialThemes = [
    'cupcake', 'bumblebee', 'emerald', 'corporate', 'synthwave', 'retro', 'cyberpunk',
    'valentine', 'halloween', 'garden', 'forest', 'aqua', 'lofi', 'pastel', 'fantasy',
    'wireframe', 'black', 'luxury', 'dracula', 'cmyk', 'autumn', 'business', 'acid',
    'lemonade', 'night', 'coffee', 'winter', 'dim', 'nord', 'sunset'
  ];
  if (theme === 'custom' || specialThemes.includes(theme)) {
    return false;
  }
  return true;
}

/**
 * Gets the stored user theme override if any ('light' | 'dark').
 */
export function getUserThemeOverride(): 'light' | 'dark' | null {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  const saved = window.localStorage.getItem(USER_THEME_STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return null;
}

/**
 * Persists the user theme override.
 */
export function setUserThemeOverride(theme: 'light' | 'dark'): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.setItem(USER_THEME_STORAGE_KEY, theme);
}

/**
 * Helper to determine if a given theme or base background color is a dark theme
 */
export function isDarkTheme(themeId?: string, baseColor?: string): boolean {
  if (themeId && themeId !== 'custom') {
    const matched = DAISY_PREBUILT_THEMES.find((t) => t.id === themeId);
    if (matched) return !!matched.isDark;
  }
  if (baseColor) {
    return calculateContrastOklch(baseColor) === '100% 0 0'; // White text on dark bg
  }
  return false;
}

/**
 * Dynamically apply or reset tenant theme branding according to DaisyUI rules.
 * Considers user light/dark mode override when tenant uses standard light or dark theme.
 */
export function applyDaisyTenantBranding(branding?: {
  theme?: string;
  primaryColor?: string;
  primaryContentColor?: string;
  secondaryColor?: string;
  secondaryContentColor?: string;
  accentColor?: string;
  accentContentColor?: string;
  neutralColor?: string;
  neutralContentColor?: string;
  baseColor?: string;
  baseContentColor?: string;
  favicon?: string;
}): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  let theme = branding?.theme;

  // Apply user theme override if tenant is on standard light/dark mode
  if (isTenantLightDarkOnly(branding)) {
    const userOverride = getUserThemeOverride();
    if (userOverride) {
      theme = userOverride;
    }
  }

  const isDark = isDarkTheme(theme, branding?.baseColor);

  // Toggle Tailwind `dark` class on root <html>
  if (isDark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  // Handle Favicon
  if (branding?.favicon) {
    const faviconLink = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement;
    if (faviconLink) {
      faviconLink.href = branding.favicon;
    }
  }

  // Handle Theme Color Meta for mobile status bars and PWA title bar
  const themeColor =
    branding?.primaryColor ||
    (isDark ? '#1D232A' : branding?.baseColor || '#ffffff');
  document
    .querySelector("meta[name='theme-color']")
    ?.setAttribute('content', themeColor);

  // Prebuilt Theme Mode
  if (
    theme &&
    theme !== 'custom' &&
    DAISY_PREBUILT_THEMES.some((t) => t.id === theme)
  ) {
    root.setAttribute('data-theme', theme);

    // If tenant is on standard light/dark theme but specified primary/secondary brand colors, apply them
    if (isTenantLightDarkOnly(branding) && (branding?.primaryColor || branding?.secondaryColor || branding?.accentColor)) {
      if (branding.primaryColor) {
        const pc = branding.primaryContentColor
          ? hexToOklch(branding.primaryContentColor)
          : calculateContrastOklch(branding.primaryColor);
        root.style.setProperty('--p', hexToOklch(branding.primaryColor));
        root.style.setProperty('--pc', pc);
      }
      if (branding.secondaryColor) {
        const sc = branding.secondaryContentColor
          ? hexToOklch(branding.secondaryContentColor)
          : calculateContrastOklch(branding.secondaryColor);
        root.style.setProperty('--s', hexToOklch(branding.secondaryColor));
        root.style.setProperty('--sc', sc);
      }
      if (branding.accentColor) {
        const ac = branding.accentContentColor
          ? hexToOklch(branding.accentContentColor)
          : calculateContrastOklch(branding.accentColor);
        root.style.setProperty('--a', hexToOklch(branding.accentColor));
        root.style.setProperty('--ac', ac);
      }
    } else {
      // Remove all custom inline variable overrides so prebuilt theme CSS rules apply 100% cleanly
      DAISY_CSS_VARIABLES.forEach((v) => root.style.removeProperty(v));
    }
    return;
  }

  // Custom Colors / Custom Theme Mode
  root.setAttribute('data-theme', isDark ? 'dark' : 'light');

  if (branding?.primaryColor) {
    const pc = branding.primaryContentColor
      ? hexToOklch(branding.primaryContentColor)
      : calculateContrastOklch(branding.primaryColor);
    root.style.setProperty('--p', hexToOklch(branding.primaryColor));
    root.style.setProperty('--pc', pc);
  } else {
    root.style.removeProperty('--p');
    root.style.removeProperty('--pc');
  }

  if (branding?.secondaryColor) {
    const sc = branding.secondaryContentColor
      ? hexToOklch(branding.secondaryContentColor)
      : calculateContrastOklch(branding.secondaryColor);
    root.style.setProperty('--s', hexToOklch(branding.secondaryColor));
    root.style.setProperty('--sc', sc);
  } else {
    root.style.removeProperty('--s');
    root.style.removeProperty('--sc');
  }

  if (branding?.accentColor) {
    const ac = branding.accentContentColor
      ? hexToOklch(branding.accentContentColor)
      : calculateContrastOklch(branding.accentColor);
    root.style.setProperty('--a', hexToOklch(branding.accentColor));
    root.style.setProperty('--ac', ac);
  } else {
    root.style.removeProperty('--a');
    root.style.removeProperty('--ac');
  }

  if (branding?.neutralColor) {
    const nc = branding.neutralContentColor
      ? hexToOklch(branding.neutralContentColor)
      : calculateContrastOklch(branding.neutralColor);
    root.style.setProperty('--n', hexToOklch(branding.neutralColor));
    root.style.setProperty('--nc', nc);
  } else {
    root.style.removeProperty('--n');
    root.style.removeProperty('--nc');
  }

  if (branding?.baseColor) {
    const b2Factor = isDark ? 1.15 : 0.93;
    const b3Factor = isDark ? 1.3 : 0.86;
    const bc = branding.baseContentColor
      ? hexToOklch(branding.baseContentColor)
      : calculateContrastOklch(branding.baseColor);
    root.style.setProperty('--b1', hexToOklch(branding.baseColor));
    root.style.setProperty(
      '--b2',
      hexToOklch(adjustHexBrightness(branding.baseColor, b2Factor)),
    );
    root.style.setProperty(
      '--b3',
      hexToOklch(adjustHexBrightness(branding.baseColor, b3Factor)),
    );
    root.style.setProperty('--bc', bc);
  } else {
    root.style.removeProperty('--b1');
    root.style.removeProperty('--b2');
    root.style.removeProperty('--b3');
    root.style.removeProperty('--bc');
  }
}

/**
 * Checks if the current document is in dark theme mode.
 */
export function isDarkThemeActive(): boolean {
  if (typeof document === 'undefined') return false;
  const root = document.documentElement;
  const currentTheme = root.getAttribute('data-theme') || '';
  const darkThemes = [
    'dark',
    'synthwave',
    'halloween',
    'forest',
    'black',
    'luxury',
    'dracula',
    'business',
    'night',
    'coffee',
    'dim',
    'sunset',
  ];
  if (darkThemes.includes(currentTheme)) return true;
  if (currentTheme === 'dark') return true;
  if (currentTheme && currentTheme !== 'light' && currentTheme !== 'custom') {
    const themeOption = DAISY_PREBUILT_THEMES.find(
      (t) => t.id === currentTheme,
    );
    if (themeOption?.isDark) return true;
  }
  if (!currentTheme && typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  return false;
}


/**
 * Toggles between light and dark theme mode and persists the user preference.
 */
export function toggleDaisyTheme(branding?: {
  theme?: string;
  primaryColor?: string;
  primaryContentColor?: string;
  secondaryColor?: string;
  secondaryContentColor?: string;
  accentColor?: string;
  accentContentColor?: string;
  neutralColor?: string;
  neutralContentColor?: string;
  baseColor?: string;
  baseContentColor?: string;
  favicon?: string;
}): 'light' | 'dark' {
  const currentIsDark = isDarkThemeActive();
  const nextTheme: 'light' | 'dark' = currentIsDark ? 'light' : 'dark';
  setUserThemeOverride(nextTheme);
  applyDaisyTenantBranding(branding);
  return nextTheme;
}
